<template>
	<div style="min-height: 720px;padding: 20px 20px 20px 0;">
		<div v-loading="loading">
			<el-table
			:data="activityTable"
			:header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
			:cell-style="{ 'text-align': 'left' }"
			style="width: 100%; margin: 20px auto"
			>
			<el-table-column  label="序号" >
					<template slot-scope="scope">
						<span>{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
			<el-table-column
				prop="name"
				label="等级名称"
			></el-table-column>
			<el-table-column  label="操作">
					<template  slot-scope="scope">
						<span @click="allocation(scope.row)" style="cursor: pointer;color: #7B61FF;">权益配置</span>
						<span @click="allocationIP(scope.row)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;">权益IP配置</span>
						<span @click="dailyOpen(scope.row)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;">日常IP配置</span>
						<span @click="festivalOpen(scope.row)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;">节假日IP配置</span>
					</template>
			</el-table-column>
			</el-table>
		</div>

		<!-- 权益配置弹窗 -->
		<equityAllocation 
		:openDialog="openAllocation" 
		:editData="editData"
		v-if="openAllocation"
		@cancel="openAllocation = false;"
		@saveData ="saveDialog"
		></equityAllocation>

		<!-- 权益IP配置 -->
		<equityAllocationIP 
		:openDialog="openAllocationIP" 
		:editData="editData"
		v-if="openAllocationIP"
		@cancel="openAllocationIP = false;"
		@saveData ="saveDialogIP"
		></equityAllocationIP>

		<!-- 日常IP配置 -->
		<dailyConfiguration 
		:openDialog="openDaily" 
		:editData="editData"
		v-if="openDaily"
		@cancel="openDaily = false;"
		@saveData ="saveDialogDaily"
		></dailyConfiguration>

		
		<!-- 节日IP配置 -->
		<festivalConfiguration 
		:openDialog="openFestival" 
		:editData="editData"
		v-if="openFestival"
		@cancel="openFestival = false;"
		@saveData ="saveDialogFestival"
		></festivalConfiguration >

	</div>
</template>

<script>
import festivalConfiguration  from "../dialog/festivalConfiguration";
import dailyConfiguration from "../dialog/dailyConfiguration";
import equityAllocationIP from "../dialog/equityAllocationIP";
import equityAllocation from "../dialog/equityAllocation";
import { getRuleInfo } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {
	equityAllocation,
	equityAllocationIP,
	dailyConfiguration,
	festivalConfiguration
},
props:{},
data() {
	return {
		loading:false,
		openAllocation:false,//权益配置弹窗
		openAllocationIP:false,//权益IP配置
		openDaily:false,//日常IP配置
		openFestival:false,//节日IP配置
		activityTable:[],
		editData:{},
	}
},
computed: {},
created() {

},
mounted() {
	this.getRuleInfo()
},
methods: {
	  //获取详情
		getRuleInfo(){
			this.loading = true,
			getRuleInfo().then((res) => {
				this.loading = false;
				if (res.code == 1) {
					this.activityTable = res.data
				}else{
					this.$message.error(res.message);
				}
			});
		},
		//打开权益配置弹窗
		allocation(item){
			this.openAllocation = true
			this.editData = item
		},
		saveDialog(){
			this.openAllocation = false
			this.getRuleInfo()
		},
		//打开权益IP配置弹窗
		allocationIP(item){
			this.openAllocationIP = true
			this.editData = item
		},
		saveDialogIP(){
			this.openAllocationIP = false
			this.getRuleInfo()
		},
		//日常IP配置弹窗
		dailyOpen(item){
			this.openDaily = true
			this.editData = item
		},
		saveDialogDaily(){
			this.openDaily = false
			this.getRuleInfo()
		},
		//节日IP配置弹窗
		festivalOpen(item){
			this.openFestival = true
			this.editData = item
		},
		saveDialogFestival(){
			this.openFestival = false
			this.getRuleInfo()
		}
}
}
</script>
<style lang='scss' scoped>

</style>